<template>
  <div
    ref="alert"
    class="gf-alert"
    :class="[variant ? `--${variant}` : '', elementClass]"
  >
    <div class="gf-alert__wrapper">
      <div
        class="gf-alert__icon"
        v-if="icon?.length > 0"
      >
        <i
          class="gf-fs-4"
          :class="icon"
        ></i>
      </div>
      <div
        class="gf-alert__content"
        :class="contentClass"
      >
        <div
          v-if="title"
          class="gf-alert__header"
          :style="{ 'margin-right': canBeClosed ? ' 15px' : '' }"
        >
          <h5 class="gf-alert__header-text">{{ title }}</h5>
        </div>
        <div
          class="gf-alert__body"
          :style="{ 'margin-right': canBeClosed && !title ? ' 15px' : '' }"
        >
          <slot name="body" />
        </div>
        <div
          v-if="canBeClosed"
          class="d-flex align-items-center gf-alert__close"
          @click="closeAlert"
        >
          <i class="gf-icon gf-icon-x" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GfCustomAlert',
  props: {
    title: {
      type: String
    },
    canBeClosed: {
      type: Boolean,
      default: false
    },
    variant: {
      type: String,
      default: ''
    },
    elementClass: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    contentClass: {
      type: String,
      default: null
    }
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    closeAlert() {
      this.$refs.alert.classList.add('--hide');
      setTimeout(() => {
        this.$refs.alert.style.display = 'none';
      }, 180);
    }
  }
};
</script>

<style lang="scss">
$this: '.gf-alert';

#{$this} {
  position: relative;
  display: grid;
  padding: 12px;
  grid-template-rows: 1fr;
  color: var(--gf-alert-c);
  background-color: var(--gf-alert-bc);
  border: 1px solid var(--gf-alert-c);
  border-radius: var(--border-radius-lg);
  transition: all 180ms cubic-bezier(0, 0, 0.3, 1);

  &.--hide {
    grid-template-rows: 0fr;
    padding: 0 12px;
    margin-bottom: 0 !important;
    border: none;
  }

  &.--primary {
    color: var(--gf-alert-primary-c);
    background-color: var(--gf-alert-primary-bc);
    border-color: var(--primary);

    #{$this}__close {
      color: var(--gf-alert-primary-c);
    }
  }

  &.--success {
    color: var(--gf-alert-success-c);
    background-color: var(--gf-alert-success-bc);
    border-color: var(--success);

    #{$this}__close {
      color: var(--gf-alert-success-c);
    }
  }

  &.--danger {
    color: var(--gf-alert-danger-c);
    background-color: var(--gf-alert-danger-bc);
    border-color: var(--danger);

    #{$this}__close {
      color: var(--gf-alert-danger-c);
    }
  }

  &.--warning {
    color: var(--gf-alert-warning-c);
    background-color: var(--gf-alert-warning-bc);
    border-color: var(--warning);

    #{$this}__close {
      color: var(--gf-alert-warning-c);
    }
  }

  #{$this}__wrapper {
    display: flex;
    gap: 8px;
    overflow: hidden;
  }

  #{$this}__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
  }

  #{$this}__header {
    margin-bottom: 8px;

    &-text {
      margin: 0;
    }
  }

  #{$this}__body {
    word-wrap: break-word;
  }

  #{$this}__close {
    position: absolute;
    top: 5px;
    right: 5px;
    padding: 5px 10px;
    font-size: 1rem;
    cursor: pointer;
    color: var(--gf-alert-color);
    transition: filter 200ms ease;

    &:hover {
      filter: brightness(125%);
    }
  }
}
</style>
